/* eslint-disable react/prop-types */
import { Cancel, Check, Delete, Edit } from "@mui/icons-material";
import InfoIcon from "@mui/icons-material/Info";
import PlaylistAddCheckCircleSharpIcon from "@mui/icons-material/PlaylistAddCheckCircleSharp";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
  darken,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import SelectCustomer from "components/SelectCustomer";
import { setHomePage, useMaterialUIController } from "context";
import dayjs from "dayjs";
import useAuth from "hooks/useAuth";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import { AlertState, IdSelectHosoState } from "states";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import {
  API_ROUTES,
  API_ROUTES_V2,
  ID_GROUP_CAPTINH,
  PermissionMenuKey,
} from "../../utils/constants";
import FormDangKySanPham from "./formDangKySanPham";
import DetailDangKySanPham from "./detailDangKySanPham";
import { JsonTool } from "../../utils/jsonTools";
import { IdExpiredProductSelectState } from "states";
import { useQuery } from "hooks/useQuery";
import { CountNotificationState } from "states";
import {
  ID_GROUP_HOIDONG,
  ID_GROUP_CHUTHE,
  ID_GROUP_NUMBER_ONE,
} from "../../utils/constants";
import DialogProgress from "components/CircularProgressWithLabel/dialogProgress";
import useAxiosPrivateForm from "hooks/useAxiosPrivateForm";

const ALLVALUE = { ma: "ALL", ten: "Tất cả" };

const dicLanDanhGia = {
  1: "Lần đầu",
  2: "Nâng hạng",
  3: "Đánh giá lại",
};
const dictTrangThai = {
  1: "Đang chấm",
  2: "Đã hoàn thành",
  3: "Hồ sơ trả, bổ sung",
};
const dictColorTrangThai = {
  1: "success",
  2: "warning",
  3: "error",
};

function HoSoDangKySanPham() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const { user } = useAuth();
  const _timeOut = useRef();
  const { chuthe } = useQuery();
  const [modalOpen, setModalOpen] = useState(false);
  const [action, setAction] = useState("Edit");
  const [tableData, setTableData] = useState({});
  const [dataRow, setDataRow] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const axiosPrivateInstance = useAxiosPrivate();
  const axiosForm = useAxiosPrivateForm();
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [title, setTitle] = useState("");
  const [alert, setAlert] = useRecoilState(AlertState);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [optionNhomSanPham, setOptionNhomSanPham] = useState([]);
  const [optionChuThe, setOptionChuThe] = useState([]);
  const [optionSanPham, setOptionSanPham] = useState([]);
  const [optionSelectSanPham, setOptionSelectSanPham] = useState([]);
  const [inforChuThe, setInforChuThe] = useState(null);
  const [detailState, setDetailState] = useState();
  const [openDetail, setOpenDetail] = useState(false);
  const [optionHoiDong, setOptionHoiDong] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [idHosoState, setIdHosoState] = useRecoilState(IdSelectHosoState);
  // Extract current query parameters
  const searchParams = new URLSearchParams(location.search);
  const [paramsState, setParamsState] = useState({
    nam: searchParams.get("nam") || null,
    matinh: ALLVALUE.ma,
    maquan: ALLVALUE.ma,
    maphuong: ALLVALUE.ma,
    chuthe: ALLVALUE.ma,
    nhomsanpham: ALLVALUE.ma,
    sanpham: ALLVALUE.ma,
    trangthai: searchParams.get("trangthai") || 1,
    hoidong: null,
    thanhvien: null,
  });

  //select product từ thông báo
  const [idProductSelect, setIdProductSelect] = useRecoilState(
    IdExpiredProductSelectState
  );

  //progress
  const _openDialog = useRef(false);
  const [openLoadingDialog, setOpenLoadingDialog] = useState(false);
  const [valueProgress, setValueProgress] = useState(0);

  //countTotalNoti
  const setCountNotificationState = useSetRecoilState(CountNotificationState);
  useEffect(() => {
    if (idProductSelect && idProductSelect.idSanPham) {
      handleToAddNew();
    }
  }, [idProductSelect]);
  //Kiểm tra nhóm người dùng với id Group
  const checkGroupUser = (user, idGroup) => {
    let check = false;
    if (user && user.id) {
      if (user?.group?.find((item) => item?.id == idGroup)) {
        check = true;
      }
    }
    return check;
  };
  //kiểm tra đang đăng nhập với nhóm chủ thể
  const isOwner = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_CHUTHE);
  }, [user]);

  //kiểm tra đang đăng nhập với nhóm hội đồng = 6
  const isHoiDong = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_HOIDONG);
  }, [user]);

  //Kiểm tra nhóm người dùng là 1
  const isGroupNumberOne = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_ONE);
  }, [user]);

  //kiểm tra nhóm người dùng là 9
  const isGroupNumberNine = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_CAPTINH);
  }, [user]);

  useEffect(() => {
    const fetchDataDataSanPham = async () => {
      try {
        const response = await axiosPrivateInstance.get(API_ROUTES.SANPHAM);
        const data = response.data?.["data"];
        let list = [{ id: "ALL", ten: "Tất cả" }];
        if (data?.length > 0) {
          list = [...list, ...data];
        }
        setOptionSanPham(list);
        setOptionSelectSanPham(list);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    const fetchDataDataNhomSanPham = async () => {
      try {
        const response = await axiosPrivateInstance.get("nhomsanpham");
        setOptionNhomSanPham(response.data["data"]);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    fetchDataDataSanPham();
    fetchDataDataNhomSanPham();
    return () => {
      setOpenLoadingDialog(false);
    };
  }, []);

  const handleDelete = async () => {
    try {
      await axiosPrivateInstance.delete(
        API_ROUTES.PHIEUDANGKYCAPTINH + "/" + selectedRow.id
      );
      // Remove the selected row from the data
      setTableData((prevData) =>
        prevData.filter((row) => row.id !== selectedRow.id)
      );
      setAlert({
        alert: true,
        message: "Xoá bản ghi thành công!",
        type: "success",
      });
    } catch (error) {
      const ms = error.response.data;
      setAlert({ alert: true, message: ms.error, type: "warning" });
    }
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleOpenDeleteConfirmation = (row) => {
    // Set the selected row and open the delete confirmation dialog
    setSelectedRow(row);
    setDeleteConfirmationOpen(true);
  };

  const handleCloseDeleteConfirmation = () => {
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleSave = (values) => {
    if (_openDialog.current) {
      _openDialog.current = false;
    }
    //khi post, put data tính progress complete
    const configCircularProgressWithLabel = {
      onUploadProgress: function (progressEvent) {
        !openLoadingDialog &&
          !_openDialog.current &&
          setOpenLoadingDialog(true);
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setValueProgress(percentCompleted);
      },
    };
    const isHasUploadFile = values?.tepdinhkem?.length > 0;
    let config = {};
    if (isHasUploadFile) {
      config = { ...configCircularProgressWithLabel };
    }
    const handleToEditSuccess = () => {
      setAlert({
        alert: true,
        message: "Cập nhật thành công!",
        type: "success",
      });
      fetchData(paramsState, pagination);
    };
    const handleToCreateSuccess = (response) => {
      let rowAdd = response.data;
      rowAdd["sanpham_ten"] = optionSanPham?.find(
        (item) => item?.id == rowAdd?.sanpham
      )?.ten;
      rowAdd["chuthe_ten"] = optionChuThe?.find(
        (item) => item?.id == rowAdd?.chuthe
      )?.ten;
      tableData.unshift(rowAdd);
      setTableData([...tableData]);
      setAlert({
        alert: true,
        message: "Thêm mới thành công!",
        type: "success",
      });
    };
    const handleToError = (error) => {
      let validErrors = {};
      let data = error?.response?.data;
      if (Array.isArray(data)) {
        let value = "";
        value = data?.join(";");
        validErrors = { ...validErrors, another: value };
      } else {
        Object.entries(data).forEach(([key, value]) => {
          let val = "";
          if (Array.isArray(value)) {
            value.map((item) => {
              val += item;
            });
          } else {
            val = value;
          }
          validErrors = { ...validErrors, [key]: val };
        });
      }
      setValidationErrors(validErrors);
    };
    if (action == "Edit") {
      axiosForm
        .put(
          API_ROUTES_V2.PHIEUDANGKYCAPTINH + "/" + values.id,
          { ...values },
          { ...config }
        )
        .then((response) => {
          if (response?.data) {
            if (isHasUploadFile) {
              setValueProgress(100);
              setTimeout(() => {
                setOpenLoadingDialog(false);
                handleToEditSuccess();
              }, [400]);
            } else {
              handleToEditSuccess();
            }
            setValidationErrors({});
            setModalOpen(false);
            setIdProductSelect(null);
          }
        })
        .catch((error) => {
          if (isHasUploadFile) {
            _openDialog.current = true;
            setOpenLoadingDialog(false);
          }
          if (error?.response?.data) {
            handleToError(error);
          } else {
            setAlert({
              alert: true,
              message: error?.message || "Lỗi!Vui lòng thử lại sau",
              type: "error",
            });
            console.log(error);
          }
          return;
        })
        .finally(() => {
          if (isHasUploadFile) {
            _openDialog.current = true;
            setOpenLoadingDialog(false);
          }
        });
    } else {
      axiosForm
        .post(
          API_ROUTES_V2.PHIEUDANGKYCAPTINH,
          {
            ...values,
          },
          { ...config }
        )
        .then((response) => {
          if (response?.data) {
            if (isHasUploadFile) {
              setValueProgress(100);
              setTimeout(() => {
                setOpenLoadingDialog(false);
                handleToCreateSuccess(response);
              }, [400]);
            } else {
              handleToCreateSuccess(response);
            }
            setValidationErrors({});
            setModalOpen(false);
            setIdProductSelect(null);
          }
        })
        .catch((error) => {
          if (isHasUploadFile) {
            _openDialog.current = true;
            setOpenLoadingDialog(false);
          }
          if (error?.response?.data) {
            handleToError(error);
          } else {
            setAlert({
              alert: true,
              message: error?.message || "Lỗi!Vui lòng thử lại sau",
              type: "error",
            });
            console.log(error);
          }
          return;
        })
        .finally(() => {
          if (isHasUploadFile) {
            _openDialog.current = true;
            setOpenLoadingDialog(false);
          }
        });
    }
  };
  useEffect(() => {
    const fetchDataChuThe = async () => {
      try {
        const response = await axiosPrivateInstance.get(
          API_ROUTES.QUANLYCHUTHE
        );
        const data = response.data?.["data"];
        let list = [{ id: "ALL", ten: "Tất cả" }];
        if (data?.length > 0) {
          list = [...list, ...data];
        }
        setOptionChuThe(list);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    const fetchDataHoiDong = async () => {
      try {
        const response = await axiosPrivateInstance.get(API_ROUTES.HOIDONG, {
          params: {
            capquanly: 3,
          },
        });
        setOptionHoiDong(response.data?.["data"]);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    fetchDataChuThe();
    fetchDataHoiDong();
  }, []);

  function fetchDataChuTheByUser(user) {
    axiosPrivateInstance
      .get(API_ROUTES.QUANLYCHUTHE, {
        params: { username: user?.username },
      })
      .then((res) => {
        setInforChuThe(res?.data?.data?.[0]);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    if (isOwner) {
      fetchDataChuTheByUser(user);
    }
  }, [isOwner, user]);

  //lấy data sản phẩm theo nhóm sản phẩm
  const fetchDataDataSanPhamByNhom = async (nhom) => {
    try {
      const response = await axiosPrivateInstance.get(API_ROUTES.SANPHAM, {
        params: { nhomsanpham: nhom, capquanly: 1 },
      });
      const data = response.data?.["data"];
      let list = [{ id: "ALL", ten: "Tất cả" }];
      if (data?.length > 0) {
        list = [...list, ...data];
      }
      setOptionSelectSanPham(list);
    } catch (error) {
      console.log(error);
      return;
    }
  };

  // Lấy toàn bộ dữ liệu
  const fetchData = async (
    { nam, nhomsanpham, sanpham, trangthai },
    { pageIndex, pageSize }
  ) => {
    if (!tableData.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    const isGroupHoiDong = checkGroupUser(user, ID_GROUP_HOIDONG);
    let body = {
      nam: nam && dayjs(nam)?.isValid() ? dayjs(nam)?.get("year") : undefined,
      nhomsanpham: nhomsanpham == ALLVALUE.ma ? undefined : nhomsanpham,
      sanpham: sanpham == ALLVALUE.ma ? undefined : sanpham,
      pageNumber: pageIndex + 1,
      countNumber: pageSize,
      trangthai: trangthai == ALLVALUE.ma ? undefined : trangthai,
      hoidong: isGroupHoiDong
        ? user?.hoidong?.map((item) => item?.id)
        : undefined,
      thanhvien: isGroupHoiDong ? user?.thanhvien : undefined,
    };
    const queries = JsonTool.convertToQueryString(body);
    const urlAPI = API_ROUTES.PHIEUDANGKYCAPTINH;
    await axiosPrivateInstance
      .get(urlAPI + "?" + queries)
      .then((res) => {
        setRowCount(res.data?.totalRecord);
        setTableData(res.data?.data);
      })
      .catch((error) => {
        console.log(error);
        setIsError(true);
        return;
      })
      .finally(() => {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
      });
  };
  useEffect(() => {
    _timeOut.current && clearTimeout(_timeOut.current);
    _timeOut.current = setTimeout(() => {
      fetchData(paramsState, pagination);
    }, [200]);
  }, [paramsState, pagination]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "sanpham_ten",
        header: "Sản phẩm",
        size: 150,
      },
      {
        accessorKey: "chuthe_ten",
        header: "Chủ thể",
        size: 150,
      },
      {
        accessorKey: "ngaydanhgia",
        header: "Ngày đánh giá",
        size: 150,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return dayjs(value)?.isValid()
            ? dayjs(value)?.format("DD/MM/YYYY")
            : value;
        },
      },
      {
        accessorKey: "noidung",
        header: "Nội dung",
        size: 200,
      },
      {
        accessorKey: "trangthai",
        header: "Trạng thái",
        size: 150,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={dictTrangThai[value]}
                color={dictColorTrangThai[value]}
                variant="gradient"
              />
            </MDBox>
          );
        },
      },
    ],
    []
  );
  const handelEditClick = async (row) => {
    const id = row.getValue("id");
    try {
      const response = await axiosPrivateInstance.get(
        API_ROUTES.PHIEUDANGKYCAPTINH + "/" + id
      );
      setDataRow({ ...response.data, rowIndex: row.index });
    } catch (error) {
      setIsError(true);
      return;
    }
    setAction("Edit");
    setTitle("Chỉnh sửa phiếu đăng ký");
    setValidationErrors({});
    setModalOpen(true);
  };

  const handleToClickDetail = async (row) => {
    const id = row.getValue("id");
    try {
      const response = await axiosPrivateInstance.get(
        API_ROUTES.PHIEUDANGKYCAPTINH + "/" + id
      );
      let detail = { ...response.data };
      detail["landanhgia_ten"] = dicLanDanhGia[detail?.landanhgia];
      detail["ngaydanhgia_format"] = dayjs(detail?.ngaydanhgia)?.isValid()
        ? dayjs(detail?.ngaydanhgia).format("DD/MM/YYYY")
        : detail?.ngaydanhgia;
      detail["trangthai_ten"] = dictTrangThai[detail?.trangthai];
      setDetailState(detail);
      setOpenDetail(true);
    } catch (error) {
      console.log(error);
      return;
    }
  };

  const handleChangeDate = (value) => {
    setParamsState((prev) => {
      const year =
        value && dayjs(value)?.isValid()
          ? dayjs(value)?.get("year")
          : undefined;
      searchParams.set("nam", year);
      navigate(`${location.pathname}?${searchParams.toString()}`);
      return {
        ...prev,
        nam: value,
      };
    });
  };
  //change Nhóm sản phẩm
  const handleChangeNhomSanPham = (e) => {
    let { value } = e.target;
    setParamsState((prev) => ({
      ...prev,
      nhomsanpham: value,
      sanpham: ALLVALUE.ma,
    }));
    if (value !== ALLVALUE.ma) {
      fetchDataDataSanPhamByNhom(value);
    } else {
      setOptionSelectSanPham(optionSanPham);
    }
  };
  const handleChangeTrangThai = (e) => {
    const { value } = e.target;
    setParamsState((prev) => ({
      ...prev,
      trangthai: value,
    }));
  };
  const handleToClearDate = () => {
    setParamsState((prev) => ({
      ...prev,
      nam: null,
    }));
  };
  const handleChangeAutoComplete = (key) => (e, newValue) => {
    setParamsState((prev) => ({
      ...prev,
      [key]: newValue ? newValue.id : ALLVALUE.ma,
    }));
  };
  const handleToCloseDetail = () => {
    setOpenDetail(false);
    setDetailState(null);
  };

  const fieldInforDetail = useMemo(() => {
    const result = [
      {
        key: "chuthe_ten",
        name: "Chủ thể",
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        key: "nhomsanpham_ten",
        name: "Nhóm Sản phẩm",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        key: "sanpham_ten",
        name: "Sản phẩm",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        key: "nam",
        name: "Năm",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        key: "landanhgia_ten",
        name: "Lần đánh giá",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        key: "ngaydanhgia_format",
        name: "Ngày đánh giá",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        key: "trangthai_ten",
        name: "Trạng thái",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        key: "noidung",
        name: "Nội dung",
        xs: 12,
        md: 12,
        lg: 12,
      },
    ];
    return result;
  }, []);
  const fieldInforContent = useMemo(() => {
    const result = [
      {
        key: "noidung_nguongoc",
        name: "Sử dụng nguyên liệu địa phương",
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        key: "noidung_laodong",
        name: "Sử dụng lao động địa phương",
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        key: "noidung_ytuong",
        name: "Nguồn gốc ý tưởng sản phẩm",
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        key: "noidung_bansac",
        name: "Bản sắc/Trí tuệ địa phương",
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        key: "noidung_khac",
        name: "Nội dung khác",
        xs: 12,
        md: 12,
        lg: 12,
      },
    ];
    return result;
  }, []);
  const handleClickChamdiem = (row) => {
    const id = row.getValue("id");
    const status = row.getValue("trangthai");
    setIdHosoState(id);
    navigate(
      `/chamdiemcaptinh/${PermissionMenuKey.ocopcaptinh}/${
        PermissionMenuKey.chamdiemhosocaptinh
      }?id=${id}${status ? `&status=${status}` : ""}`
    );
  };
  const handleToAddNew = () => {
    setAction("New");
    setTitle("Thêm mới phiếu đăng ký");
    setDataRow({});
    setValidationErrors({});
    setModalOpen(true);
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        pt={6}
        py={3}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "0.5rem",
          px: 3,
        }}
      >
        <Grid
          container
          spacing={2}
          rowSpacing={2}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          <Grid item xs={4} md={3} lg={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={paramsState?.nam ? dayjs(paramsState.nam) : null}
                views={["year"]}
                onChange={handleChangeDate}
                slotProps={{
                  textField: {
                    InputLabelProps: { shrink: true },
                    placeholder: "---Chọn năm---",
                    fullWidth: true,
                    inputProps: {
                      readOnly: true,
                    },
                  },
                  field: {
                    clearable: true,
                    onClear: handleToClearDate,
                  },
                }}
                label="Năm"
                sx={{
                  ".MuiInputLabel-shrink": {
                    fontSize: "0.875rem",
                    lineHeight: "1.6",
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <SelectCustomer
              keyValue="nhomsanpham"
              label="Nhóm sản phẩm"
              labelName="ten"
              option={optionNhomSanPham}
              onChange={handleChangeNhomSanPham}
              state={paramsState.nhomsanpham}
              unicode="id"
            />
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <Autocomplete
              sx={{
                ".MuiAutocomplete-input": {
                  padding: "7px 4px 7px 16px !important",
                },
              }}
              id="combo-box-sanPham"
              options={optionSelectSanPham}
              getOptionLabel={(option) => option.ten}
              value={
                optionSelectSanPham?.find(
                  (option) => option.id === paramsState.sanpham
                ) || null
              }
              onChange={handleChangeAutoComplete("sanpham")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Sản phẩm"
                  placeholder="Chọn sản phẩm"
                  disabled={optionSanPham?.length > 0 ? false : true}
                />
              )}
              renderOption={(props, options) => (
                <Box component="li" {...props} key={options.id}>
                  {options.ten}
                </Box>
              )}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={8} md={3} lg={3}>
            <SelectCustomer
              keyValue="trangthai"
              label="Trạng thái"
              labelName="ten"
              option={[
                { id: 1, ten: "Đang chấm" },
                { id: 2, ten: "Đã hoàn thành" },
                { id: 3, ten: "Hồ sơ trả, bổ sung" },
              ]}
              onChange={handleChangeTrangThai}
              state={paramsState.trangthai}
              unicode="id"
            />
          </Grid>
        </Grid>
      </MDBox>
      <MDBox py={3}>
        <MaterialReactTable
          muiToolbarAlertBannerProps={
            isError
              ? {
                  color: "error",
                  children: "Lỗi khi lấy dữ liệu",
                }
              : undefined
          }
          enableRowNumbers
          rowNumberMode="static"
          columns={columns}
          data={tableData}
          enableFilters={true}
          enableHiding={false}
          enableColumnOrdering={false}
          enableDensityToggle={true}
          enableColumnResizing
          enableGrouping
          enableEditing
          manualPagination
          onPaginationChange={setPagination}
          rowCount={rowCount}
          localization={MRT_Localization_VI}
          positionActionsColumn="last"
          displayColumnDefOptions={{
            "mrt-row-actions": {
              size: isHoiDong ? 80 : 100,
            },
          }}
          renderRowActions={({ row, table }) => (
            <Box sx={{ display: "flex" }}>
              {isHoiDong ? (
                <>
                  <Tooltip arrow placement="left" title="Chi tiết">
                    <IconButton
                      color="success"
                      onClick={() => handleToClickDetail(row)}
                    >
                      <InfoIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip
                    arrow
                    placement="left"
                    title={
                      row.original.trangthai == 2
                        ? "Xem phiếu chấm"
                        : "Chấm điểm"
                    }
                  >
                    <IconButton
                      color="primary"
                      onClick={() => handleClickChamdiem(row)}
                    >
                      <PlaylistAddCheckCircleSharpIcon />
                    </IconButton>
                  </Tooltip>
                </>
              ) : (
                <>
                  <Tooltip arrow placement="left" title="Chi tiết">
                    <IconButton
                      color="success"
                      onClick={() => handleToClickDetail(row)}
                    >
                      <InfoIcon />
                    </IconButton>
                  </Tooltip>
                  {(row.getValue("trangthai") == 1 ||
                    row.getValue("trangthai") == 3) && (
                    <>
                      <Tooltip arrow placement="left" title="Chỉnh sửa">
                        <IconButton
                          color="info"
                          onClick={() => handelEditClick(row)}
                        >
                          <Edit />
                        </IconButton>
                      </Tooltip>
                      <Tooltip arrow placement="right" title="Xoá">
                        <IconButton
                          color="primary"
                          onClick={() => {
                            let _data = [];
                            _data["id"] = row.getValue("id");
                            _data["sanpham_ten"] = row.getValue("sanpham_ten");
                            _data["ngaydanhgia"] = row.getValue("ngaydanhgia");
                            handleOpenDeleteConfirmation(_data);
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                </>
              )}
            </Box>
          )}
          //   renderTopToolbarCustomActions={() => (
          //     <Stack spacing={2} direction="row" color="white">
          //       {!isHoiDong ? (
          //         <>
          //           <Button
          //             variant="contained"
          //             startIcon={<AddIcon />}
          //             sx={{ color: "#ffffff" }}
          //             onClick={handleToAddNew}
          //           >
          //             Tạo mới
          //           </Button>
          //         </>
          //       ) : (
          //         <></>
          //       )}
          //     </Stack>
          //   )}
          initialState={{
            isLoading: true,
            columnVisibility: {
              id: false,
            },
            density: "compact",
          }}
          state={{
            pagination,
            isLoading,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
          }}
          muiTablePaperProps={{
            elevation: 0,
            sx: {
              borderRadius: "0",
              border: "1px solid rgb(211 225 245)",
              backgroundColor: "#fff",
            },
          }}
          muiTableBodyProps={{
            sx: (theme) => ({
              "& tr:nth-of-type(odd)": {
                backgroundColor: darken(theme.palette.background.default, 0.1),
              },
            }),
          }}
        />
        <FormDangKySanPham
          data={dataRow}
          open={modalOpen}
          title={title}
          onClose={() => {
            setModalOpen(false);
            setValidationErrors({});
            setIdProductSelect(null);
          }}
          onSubmit={handleSave}
          validationErrors={validationErrors}
          action={action}
          dataChuThe={optionChuThe}
          inforChuThe={inforChuThe}
          isShowHoiDong={isGroupNumberOne || isGroupNumberNine}
          dataHoiDong={optionHoiDong}
          sanPhamSelect={idProductSelect}
          fieldContent={fieldInforContent}
        />
        {/* Delete Confirmation Dialog */}
        <Dialog
          open={deleteConfirmationOpen}
          onClose={handleCloseDeleteConfirmation}
        >
          <DialogTitle>Xoá bảng ghi</DialogTitle>
          <DialogContent>
            <Typography>
              Bạn muốn xoá phiếu đăng ký sản phẩm tên:{" "}
              {selectedRow?.sanpham_ten} với ngày đánh giá{" "}
              {dayjs(selectedRow?.ngaydanhgia)?.isValid()
                ? dayjs(selectedRow?.ngaydanhgia)?.format("DD/MM/YYYY")
                : selectedRow?.ngaydanhgia}{" "}
              không?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handleCloseDeleteConfirmation}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <MDButton
              color="primary"
              onClick={handleDelete}
              variant="contained"
              startIcon={<Check />}
              size="small"
              sx={{ float: "right", mr: 1 }}
            >
              Đồng ý
            </MDButton>
          </DialogActions>
        </Dialog>
        <DetailDangKySanPham
          data={detailState}
          open={openDetail}
          onClose={handleToCloseDetail}
          fieldInfor={fieldInforDetail}
          fieldContent={fieldInforContent}
        />
      </MDBox>
      <DialogProgress open={openLoadingDialog} value={valueProgress} />
      <Footer />
    </DashboardLayout>
  );
}

export default HoSoDangKySanPham;
